import { ActionTypes } from "../ProjectActionTypes";
import { JobsStatus } from "../../Models/ProjectJobsStatus";

export type ProjectJobsStatusPayload = {
    projectId?: number;
    errorCode?: string;
    data?: JobsStatus | null;
  };

export type ProjectJobsStatusModalAction = {
    type: any;
    payload?: ProjectJobsStatusPayload;
  };

export const getProjectJobsStatusLoadingAction = (projectId?: number) => {
    const projectAction: ProjectJobsStatusModalAction = {
        type: ActionTypes.GET_PROJECT_JOBS_STATUS_LOADING,
        payload: { projectId: projectId },
    };
    return projectAction;
};

export const getProjectJobsStatusAction = (projectId?: number, data?: JobsStatus | null ) => {
    const projectAction: ProjectJobsStatusModalAction = {
        type: ActionTypes.GET_PROJECT_JOBS_STATUS_SUCCESS,
        payload: { projectId: projectId, data: data },
    };
    return projectAction;
};

export const getProjectJobsStatusErrorAction = (errorCode: string) => {
    const projectListAction: ProjectJobsStatusModalAction = {
        type: ActionTypes.GET_PROJECT_JOBS_STATUS_ERROR,
        payload: { errorCode: errorCode },
    };
    return projectListAction;
};
  